define('bizzabo/models/community/PersonCollection',['backbone', 'bizzabo/models/Person'], function (Backbone, Person) {

    var PersonCollection = Backbone.Collection.extend({
        model: Person,

        setPersonSearch: function(personSearch) {
            var thisCollection = this;
            this.personSearch = personSearch;
            this.personSearch.on('change:person', function() {
                var list = this.personSearch.get('person');
                var offset = (this.personSearch.query && this.personSearch.query.get('offset')) || 0;
                if (offset > 0) {
                    this.set(list, {
                        remove: false,
                        add: true,
                        merge: true
                    });
                } else {
                    this.reset(list);
                }
            }, this);
        }

    });

    return PersonCollection;
});
